import {AnalyticsEventHandler} from "../../../infrastructure/handlers/analytics-event-handler";
import {AnalyticsService} from "../../../third-party-services/analytics/analytics-service";
import type {LivePenaltiesModuleState} from "../models/live-penalties-module.state";
import type {LivePenaltiesModuleController} from "../live-penalties-module.controller";
import {LIVE_PENALTIES} from "../live-penalties-module.consts";
import {LivePenaltiesModuleDisplayEventModel} from "../models/live-penalties-module.display.event-model";

export class LivePenaltiesModuleDisplayEventHandler extends AnalyticsEventHandler {
  type = LIVE_PENALTIES.ACTION_TYPES.onDisplay;
  state: LivePenaltiesModuleState;
  controller: LivePenaltiesModuleController;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = LivePenaltiesModuleDisplayEventModel;
  }
}
